module.exports = __webpack_public_path__ + "static/media/rat.f97f375e.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/rat.m4a
// module id = 554
// module chunks = 0